import { Routes } from '@angular/router';
import { AuthenticatedGuardCanActivateChild } from '@pinnakl/auth/providers';
import { SecurityService } from '@pinnakl/poems';

import { checkEmsV3Access } from '@pinnakl/poems/trade-workflow-spec/shared';

import { RedirectComponent } from '@pinnakl/shared/base-components';
import { AppNames } from '@pinnakl/shared/types';

const authRoutes: Routes = [
  {
    path: 'cash-flow',
    loadChildren: () => import('./cash-flow/cash-flow.routes').then(m => m.CASH_FLOW_ROUTES),
  },
  {
    path: 'user-settings',
    loadChildren: () => import('@pinnakl/user-settings/shell').then(m => m.USER_SETTINGS_ROUTES(AppNames.PLATFORM_WEB)),
  },
  {
    path: 'corporate-actions',
    providers: [],
    loadChildren: () =>
      import('./corporate-actions/corporate-actions-ui/corporate-actions.routes').then(m => m.CORPORATE_ACTIONS_ROUTES),
  },
  {
    path: 'dashboard',
    providers: [],
    loadChildren: () => import('./dashboard/dashboard-ui/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
  },
  {
    path: 'ems',
    providers: [],
    loadChildren: () => import('@pinnakl/poems/ems/shell').then(m => m.EMS_ROUTES),
  },
  {
    path: 'ems-v3',
    canMatch: [checkEmsV3Access],
    providers: [],
    loadChildren: () => import('@pinnakl/poems/ems-v3/shell').then(m => m.EMS_V3_ROUTES),
  },
  {
    path: 'rebalancing',
    providers: [],
    loadChildren: () => import('@pinnakl/rebalancing/features/home').then(m => m.REBALANCING_ROUTES),
  },
  {
    path: 'oms',
    loadChildren: () => import('./oms/oms.routes').then(m => m.OMS_ROUTES),
  },
  {
    path: 'pms',
    loadChildren: () => import('@pinnakl/pms/shell').then(m => m.PMS_ROUTES),
  },
  {
    path: 'pricing',
    loadChildren: () => import('./pricing/pricing.routes').then(m => m.PRICING_ROUTES),
  },
  {
    path: 'attribution',
    providers: [],
    loadChildren: () => import('@pinnakl/performance-attribution/shell').then(m => m.PERFORMANCE_ATTRIBUTION_ROUTES),
  },
  {
    path: 'reconciliation',
    loadChildren: () => import('./reconciliation/reconciliation.routes').then(m => m.RECONCILIATION_ROUTES),
  },
  {
    path: 'reporting',
    loadChildren: () => import('@pinnakl/reporting').then(m => m.REPORTING_ROUTES),
    data: { projectName: AppNames.PLATFORM_WEB },
  },
  {
    path: 'risk',
    loadChildren: () => import('./risk/risk-ui/risk-home/risk-home.routes').then(m => m.RISK_HOME_ROUTES),
  },
  {
    path: 'securities',
    providers: [SecurityService],
    loadChildren: () => import('@pinnakl/securities/shell').then(m => m.SECURITIES_ROUTES),
  },
  {
    path: 'stock-loan',
    loadChildren: () => import('@pinnakl/stock-loan/shell').then(m => m.STOCK_LOAN_ROUTES),
  },
  {
    path: 'shadow-nav',
    loadChildren: () => import('./shadow-nav/shadow-nav-ui/shadow-nav.routes').then(m => m.SHADOW_NAV_ROUTES),
  },
  {
    path: 'bulk-data-upload',
    loadChildren: () => import('@pinnakl/crm/files/shell').then(m => m.FILES_ROUTES),
  },
  {
    path: 'configuration',
    providers: [],
    loadChildren: () => import('@pinnakl/poems/configuration/shell').then(m => m.CONFIGURATION_ROUTES),
  },
  {
    path: 'api-playground',
    loadChildren: () => import('@pinnakl/shared/ui/api-playground').then(m => m.API_PLAYGROUND_ROUTES),
  },
  {
    path: 'redirect',
    component: RedirectComponent,
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];

export const platformAppRoutes: Routes = [
  {
    path: '',
    canActivateChild: [AuthenticatedGuardCanActivateChild],
    children: [...authRoutes],
  },
];
